import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { AccountingHeading } from 'src/features/accountingHeaders/utils/types';
import { LIST_ACCOUNTING_HEADINGS_RESOURCE } from 'src/features/accountingHeaders/api/useListAccountingHeadings';
import { accountingHeadersMessages } from 'src/features/accountingHeaders/utils/messages';
import AccountingHeaderFormModal from 'src/features/accountingHeaders/components/forms/AccountingHeaderFormModal';
import { useCreateAccountingHeader } from 'src/features/accountingHeaders/api/useCreateAccountingHeader';

interface CreateAccountingHeaderFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedAccountingHeading?: AccountingHeading;
    children?: React.ReactNode;
}

function CreateAccountingHeaderFormModal<TData>({ className, semantics }: CreateAccountingHeaderFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateAccountingHeader({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ACCOUNTING_HEADINGS_RESOURCE] });
            toast({
                title: formatMessage(accountingHeadersMessages.createAccountingHeadingSuccess),
                description: formatMessage(accountingHeadersMessages.createAccountingHeadingSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <AccountingHeaderFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(accountingHeadersMessages.addAccountingHeadingSubtitle)}
        />
    );
}

export default CreateAccountingHeaderFormModal;
